const init_header = require('./parts/_header');
const init_anchor = require('./parts/_anchor');
const init_photo_contest = require('./parts/_photo-contest');

function initialize_all() {
  init_header();
  init_anchor();
  init_photo_contest();
}

if (document.readyState !== 'loading') {
  initialize_all();
} else {
  document.addEventListener('DOMContentLoaded', initialize_all);
}


